@switch (layout()) { @case ('1') {
<div class="product-category-one">
  <div class="category-name" [ngClass]="stylesCSS()" [attr.data-testing-id]="'category-' + category().uniqueId">
    <a [routerLink]="category() | ishCategoryRoute">
      <img loading="lazy" [src]="categoryImageUrl" itemprop="image" [attr.alt]="category().name" />
      <h3>{{ category().name }}</h3>
    </a>
  </div>
</div>
} @case ('2') {
<div class="product-category-two">
  <div class="category-name" [ngClass]="stylesCSS()" [attr.data-testing-id]="'category-' + category().uniqueId">
    <a [routerLink]="category() | ishCategoryRoute">
      <div class="product-category-two-img-wrapper">
        <img loading="lazy" [src]="categoryImageUrl" itemprop="image" [attr.alt]="category().name" />
      </div>
      <h3>{{ category().name }}</h3>
    </a>
  </div>
</div>
} @case ('3') {
<div class="product-category-three">
  <div class="category-name" [ngClass]="stylesCSS()" [attr.data-testing-id]="'category-' + category().uniqueId">
    <a [routerLink]="category() | ishCategoryRoute">
      <div class="product-category-three-img-wrapper">
        <img loading="lazy" [src]="categoryImageUrl" itemprop="image" [attr.alt]="category().name" />
      </div>
      <h3>{{ category().name }}</h3>
    </a>
  </div>
</div>
} @case ('4') {
<div class="product-category-four">
  <div class="category-name" [ngClass]="stylesCSS()" [attr.data-testing-id]="'category-' + category().uniqueId">
    <a [routerLink]="category() | ishCategoryRoute">
      <div class="product-category-four-animation">
        <div class="product-category-four-img-wrapper">
          <img loading="lazy" [src]="categoryImageUrl" itemprop="image" [attr.alt]="category().name" />
        </div>
      </div>
      <h3>{{ category().name }}</h3>
    </a>
  </div>
</div>
}@default {
<div class="product-category-one">
  <div class="category-name" [ngClass]="stylesCSS()" [attr.data-testing-id]="'category-' + category().uniqueId">
    <a [routerLink]="category() | ishCategoryRoute">
      <img loading="lazy" [src]="categoryImageUrl" itemprop="image" [attr.alt]="category().name" />
      <h3>{{ category().name }}</h3>
    </a>
  </div>
</div>
} }
